import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore, selectIsAuthenticated, selectOnboarding } from '@/stores/useAuthStore'

interface PublicRouteProps {
  children: React.ReactNode
}

export function PublicRoute({ children }: PublicRouteProps) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const onboarding = useAuthStore(selectOnboarding)
  const location = useLocation()

  if (isAuthenticated) {
    // After registration, onboarding is set to { completed: false }.
    // Redirect to /onboarding instead of /chat to avoid a redirect
    // chain (chat -> onboarding check -> redirect to onboarding)
    // which can cause a blank screen race condition.
    if (onboarding && !onboarding.completed) {
      return <Navigate to="/onboarding" replace />
    }
    // Chat is home — the chat-first pivot.
    const from = (location.state as { from?: string })?.from || '/chat'
    return <Navigate to={from} replace />
  }

  return <>{children}</>
}
